module.exports = __webpack_public_path__ + "img/10.0cd142dd.png";